const r = {
  id: "PuertoRicoKino",
  logo: !0,
  name: "Kino",
  style: {
    colorAccent: "#DD8400",
    colorPrimary: "#624784",
    highFrequency: {
      backButtonColor: "var(--color-text-primary-primary)",
      ball: {
        background: "radial-gradient(50% 50% at 50% 50%, #8675B3 25%, var(--color-pr-kino, #533D8D) 100%)",
        highlight: "0 0 1.75rem 0 #624784",
        selected: {
          background: "#624784",
          borderColor: "#E30779",
          textColor: "var(--color-text-primary-primary-inverted)"
        },
        shadow: "linear-gradient(90deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.40) 50%, rgba(0, 0, 0, 0.00) 100%)",
        textColor: "var(--color-text-primary-primary-inverted)"
      },
      colorPrimaryAccent: "#624784",
      nextDraw: {
        background: "radial-gradient(48.02% 77.4% at 50% 46.16%, rgba(255, 189, 90, 0.40) 0%, rgba(247, 153, 14, 0.90) 100%)",
        backgroundColor: "#F7990EE5",
        notOperating: {
          cardBackground: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, var(--color-pr-kino-primary, rgba(255, 165, 31, 0.90)) 100%)",
          numberColor: "var(--color-text-secondary-secondary)"
        },
        pending: {
          cardBackground: "linear-gradient(65deg, rgba(255, 255, 255, 0.80) 15.9%, rgba(255, 255, 255, 0.40) 84.1%)",
          numberColor: "var(--color-text-primary-primary)",
          progressbarColor: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, var(--color-pr-kino-primary, rgba(255, 165, 31, 0.90)) 100%)"
        },
        ready: {
          cardBackground: "linear-gradient(270deg, rgba(255, 255, 255, 0.90) 0%, var(--color-pr-kino-primary, rgba(255, 165, 31, 0.90)) 100%)",
          numberColor: "#624784"
        },
        textColor: "var(--color-text-primary-primary)"
      },
      order: {
        background: "linear-gradient(180deg, var(--color-pr-kino-accent, #FFF) 0%, var(--color-pr-kino-primary, #FFA51F) 26.62%, var(--color-pr-kino-primary, #FFA51F) 68.75%, var(--color-pr-kino-primary, #FFA51F) 90%)",
        backgroundColor: "#FFA51F",
        topSection: {
          gradient: "radial-gradient(45.73% 50% at 50% 42.67%, rgba(255, 255, 255, 0.00) 0%, rgba(255, 165, 31, 0.60) 69.23%, rgba(255, 165, 31, 0.95) 100%)",
          textColor: {
            primary: "var(--color-text-primary-primary)",
            secondary: "#595e99"
          }
        }
      },
      results: {
        bottomGradient: "linear-gradient(90deg, var(--color-pr-kino-accent, rgba(255, 255, 255, 0.80)) 0%, var(--color-pr-kino-primary, rgba(255, 165, 31, 0.80)) 100%)",
        bottomText: "var(--color-text-primary-primary)"
      },
      teaser: {
        backgroundColor: "#FFFFFF",
        backgroundGradient: "radial-gradient(62.76% 50% at 50% 52.02%, rgba(255, 157, 13, 0.00) 0%, rgba(255, 157, 13, 0.60) 60.1%, #FF9D0D 100%)",
        jackpotColor: "#624784",
        logoColor: "#624784",
        textColor: "var(--color-text-primary-primary)",
        watch: {
          backgroundGradient: "linear-gradient(180deg, var(--color-pr-kino-tertiary, #624784) 45.24%, var(--color-pr-kino-tertiary, #624784) 99.65%)",
          badge: {
            background: "transparent",
            borderColor: "#FFFFFF",
            gameColor: "#624784",
            textColor: "#252525"
          },
          footerColor: "var(--color-text-primary-primary-inverted)",
          gameBackgroundGradient: "radial-gradient(62.76% 50% at 50% 52.02%, rgba(255, 157, 13, 0.00) 0%, rgba(255, 157, 13, 0.60) 60.1%, #FF9D0D 100%)",
          icon: {
            arrowsColor: "#252525",
            arrowsColorFade: "#FFBA2C",
            pauseColor: "#252525",
            timerColor: "#252525"
          },
          newGameColor: "#AE3026",
          play: {
            colorEnd: "#624784",
            colorStart: "#72769F",
            dropShadowColor: "rgb(174, 48, 38, 27%)",
            shadowColor: "#2E368E"
          },
          titleColor: "#624784"
        }
      },
      watchMode: {
        background: "linear-gradient(180deg, var(--color-pr-kino-accent, #FFF) 0%, var(--color-pr-kino-primary, #FFA51F) 34.62%, var(--color-pr-kino-primary, #FFA51F) 68.75%, var(--color-pr-kino-primary, #FFA51F) 90%)",
        badge: {
          background: "transparent",
          borderColor: "#FFFFFF",
          gameColor: "#624784",
          textColor: "#252525"
        },
        main: {
          background: "radial-gradient(48.02% 77.4% at 50% 46.16%, rgba(255, 189, 90, 0.40) 0%, rgba(247, 153, 14, 0.90) 100%)",
          card: {
            background: "#FFA51F",
            borderColor: "#FFFFFF"
          }
        },
        textColor: "var(--color-text-primary-primary)"
      }
    }
  }
};
export {
  r as default
};
